// Get effective status (treats over-compliant as its own category)
export const getEffectiveStatus = (overallStatus, overComplianceReason) => {
  if (overComplianceReason && overComplianceReason !== 'None' && overComplianceReason.trim() !== '') {
    return 'Over-Compliant';
  }
  return overallStatus || 'Not Evaluated';
};

// Format currency for display
export const formatCurrency = (amount) => {
  if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}M`;
  }
  if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(0)}K`;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Format full currency without abbreviations
export const formatFullCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Format violation type for display
export const getViolationTypeLabel = (type) => {
  const labels = {
    'Overtime': 'Overtime',
    'DoubleTime': 'Double Time',
    'MealBreak': 'Meal Break',
    'RestBreak': 'Rest Break'
  };
  return labels[type] || type;
};

// Get over-compliance type label
export const getOverComplianceTypeLabel = (type) => {
  if (type === 'meal_break') return 'Meal Break';
  if (type === 'double_time') return 'Double Time';
  return 'Overtime';
};

// Get period abbreviation
export const getPeriodAbbrev = (period) => {
  if (period === 'monthly') return 'mo';
  if (period === 'quarterly') return 'qtr';
  return 'yr';
};

// Get period label suffix
export const getPeriodLabel = (period) => {
  if (period === 'monthly') return '/mo';
  if (period === 'quarterly') return '/qtr';
  return '/yr';
};
